import { z } from "zod";

export const HealthSchema = z.object({
  ok: z.literal(true),
  name: z.string(),
  version: z.string(),
  time: z.string(),
});

export type Health = z.infer<typeof HealthSchema>;

/**
 * Standard error envelope. Every non-2xx API response uses this shape.
 * `error` mirrors `message` so older clients / smoke scripts keep working.
 */
export const ApiErrorSchema = z.object({
  errorId: z.string().regex(/^CK-[A-Z0-9]{6}$/),
  code: z.string().min(1),
  message: z.string().min(1),
  /** Alias of `message` — kept for AGENTS.md / older readers. */
  error: z.string().min(1),
});

export type ApiError = z.infer<typeof ApiErrorSchema>;
